<script>
    import { searchAndRemoveClasses } from "../../../commonjs/helpers";

    export default {
        name: "AnimationsMixin",
        data () {
            return {
                animationDurationOptions : [
                    {label: "Fast", value : "anim-fast"},
                    {label: "Normal", value : "anim-normal"},
                    {label: "Slow", value : "anim-slow"},
                ],
                animationDurationClassesMap : [
                    { label : "Fast" , value : "anim-fast"},
                    { label : "Normal" , value : "anim-normal"},
                    { label : "Slow" , value : "anim-slow"}
                ],
                animationClassesMap : [
                    { label: "None", value : "noAnimation"},
                    { label: "Fade in", value : "fade-in" },
                    { label: "Scale up", value : "scale-up" },
                    { label: "Scale down", value : "scale-down" },
                    { label: "Slide to right", value : "slide-to-right" },
                    { label: "Slide to left", value : "slide-to-left" },
                    { label: "Slide to bottom", value : "slide-to-bottom" },
                    { label: "Slide to top", value : "slide-to-top" },
                    { label: "Rotate", value : "rotate" },
                    { label: "Blink", value : "blink" },
                    { label: "Bounce", value : "bounce" },
                    { label: "Pulse", value : "pulse" },
                    { label: "Jello", value : "jello" },
                    { label: "Wobble", value : "wobble" },
                    { label: "Vibrate", value : "vibrate" }
                ],
            }
        },
        computed: {
            possibleAnimationClassesArr () {
                return this.animationClassesMap.map( ( animationData, index ) => {
                    return animationData.value;
                },[]);
            },
            possibleAnimationDurationClassesArr () {
                return this.animationDurationClassesMap.map( ( animationDurationData, index ) => {
                    return animationDurationData.value;
                },[]);
            },
        },
        methods: {
            getAnimationDurationOptions () {
                return this.animationDurationOptions;
            },
            getAnimationListOptions () {
                return this.animationClassesMap;
            },
            getAnimationType() {
                return this.myData.animationData && this.myData.animationData.animationType ? this.myData.animationData.animationType : "noAnimation";
            },
            getAnimationDuration () {
                let nodeAnimDuration = "anim-normal";

                if (this.myNode) {
                    this.animationDurationClassesMap.map( animationDurationData => {
                        if (this.myNode.classList.contains(animationDurationData.value)) {
                            nodeAnimDuration = animationDurationData.value;
                        }
                    })
                }

                return nodeAnimDuration;
            },
            getAnimationDelay () {
                return this.myData.animationData && this.myData.animationData.animationDelay ? this.myData.animationData.animationDelay : 0;
            },
            setAnimationType (eventData) {
                //always remove  class for animation type
                this.removeAnimationTypeClass();

                let existingAnimationData = this.myData.animationData ? { animationData : copyJson(this.myData.animationData) } : {animationData : {}};


                if (eventData.value === "noAnimation") {
                    this.removeAnimationTriggerClass();
                    this.myNode.classList.remove(this.getAnimationDuration());
                    existingAnimationData.animationData = null;
                } else {
                    //break thread to trigger animation
                    window.setTimeout( () => {
                        this.setAnimationTypeClass(eventData.value);
                        this.myNode.classList.add(this.getAnimationDuration());
                        this.myNode.classList.add("learnworlds-animated");
                    },1);
                    existingAnimationData.animationData.animationType = eventData.value;
                }

                this.setChangesAreSaved(false);
                this.changeMyData(existingAnimationData);
            },
            removeAnimationTypeClass () {
                searchAndRemoveClasses(this.myNode, this.possibleAnimationClassesArr);
            },
            setAnimationTypeClass (type) {
                let animationEndCallback = () => {
                    window.eventBus.$emit("recompute-layout");
                    this.myNode.removeEventListener("animationend", animationEndCallback);
                }

                this.myNode.addEventListener("animationend", animationEndCallback);

                this.myNode.classList.add(type);


            },
            triggerAnimation () {
                let existingAnim = this.getAnimationType();
                this.removeAnimationTriggerClass();
                this.removeAnimationTypeClass();


                window.setTimeout( () => {
                    this.myNode.classList.add("learnworlds-animated");
                    this.setAnimationTypeClass(existingAnim);

                },1);
            },
            removeAnimationTriggerClass(wrapper) {
                if (!wrapper) {
                    wrapper = this.myNode;
                }

                wrapper.classList.remove("learnworlds-animated");
            },
            setAnimationDuration (data) {
                let animationType = this.getAnimationType();

                searchAndRemoveClasses(this.myNode, this.possibleAnimationDurationClassesArr);
                this.removeAnimationTypeClass();

                this.myNode.classList.add(data.value);
                this.myNode.classList.remove("learnworlds-animated");

                //break thread to trigger animation
                window.setTimeout( () => {
                    this.myNode.classList.add("learnworlds-animated");
                    this.myNode.classList.add(animationType);
                },1);

                this.setChangesAreSaved(false);

            },
            setAnimationDelay (eventData) {
                let existingAnimationData = this.myData.animationData ? { animationData : this.myData.animationData } : {animationData : {}};
                existingAnimationData.animationData.animationDelay = eventData.value;
                this.changeMyData(existingAnimationData);
                this.setChangesAreSaved(false);
            },
            checkAnimationTrigger () {
                if (this.myData && this.myData.animationData && this.myData.animationData.animationType) {
                    $(this.myNode).on('inview', (event, isInView, visiblePartX, visiblePartY) =>  {

                        if (isInView && !this.animationHasTriggered) {
                            if (this.myData.animationData.animationDelay) {
                                window.setTimeout(this.triggerAnimation,this.myData.animationData.animationDelay);
                            } else {
                                this.triggerAnimation();
                            }

                            this.animationHasTriggered = true;
                        }
                    })
                }
            }
        }
    }
</script>

